/** Base design resolution — see ASSET.md section 1. */
export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

/** Palette pulled from ASSET.md section 4. */
export const COLORS = {
  halloweenOrange: 0xff8c3b,
  halloweenPurple: 0x5b3a8e,
  christmasBlue: 0x3b7dff,
  christmasRed: 0xe84c4c,
  christmasWhite: 0xf5f8ff,
  fusionGold: 0xffd166,
  outline: 0x2e2a38,
  background: 0x2e2a38
} as const;

/** Two equal sorting compartments: Halloween on the left, Christmas on the right. */
export const BASKET_WIDTH = 320;
export const BASKET_HEIGHT = 70;
export const ITEM_SIZE = 64;
export const CATCH_LINE_Y = GAME_HEIGHT - 110;

export const STORAGE_KEY = 'spooky-stockings-save-v1';
